import { Alert, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import EsignatureRequester from 'modules/documents/components/BulkFiles/DocumentAssigner/EsignatureRequester/index'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'
import type { AssignEsignatureForm } from 'modules/documents/lib/forms/AssignEsignatureForm'

interface Props {
  selectedIdsForEsignature: string[]
  requestEsignatureForm: AssignEsignatureForm
  uploadProcess: UploadProcess
  onSelectIdsForEsignature: (arg0: string[]) => void
  countMatches: number
  remainingDocs: number
}

const MatchWithSignature = ({
  selectedIdsForEsignature,
  requestEsignatureForm,
  uploadProcess,
  onSelectIdsForEsignature,
  countMatches,
}: Props) => {
  if (countMatches === 0) {
    return (
      <Box paddingTop="s8">
        <Alert>{i18n.t('split_documents.bulk_modal.alert')}</Alert>
      </Box>
    )
  }

  return (
    <Box>
      <Box
        padding="s16"
        borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
        background="grey000White"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
          top: {
            width: 's1',
            style: 'hidden',
            color: 'grey400',
          },
        }}
      >
        <EsignatureRequester
          selectedIdsForEsignature={selectedIdsForEsignature}
          requestEsignatureForm={requestEsignatureForm}
          onSelectIdsForEsignature={onSelectIdsForEsignature}
          recipientsCount={countMatches}
          uploadProcess={uploadProcess}
        />
      </Box>
    </Box>
  )
}

export default MatchWithSignature
